import React from "react"
import { useEffect, useState } from "react"
import "./Card.css"
import PropTypes from "prop-types"
import {
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBCol,
} from "mdb-react-ui-kit"
import "bootstrap/dist/css/bootstrap.min.css"

function Card({ title, imgSource, data, idCategoria, handleMatrixChange, isEnglish }) {
  const [rubros, setRubros] = useState([])
  const [todoMarcados, setTodoMarcados] = useState(false)
  const [itemsChecked, setItemsChecked] = useState([])

  let columnClass = '';

  if (idCategoria === 1) {
    columnClass = 'food-column';
  } else if (idCategoria === 2) {
    columnClass = 'transport-column';
  } else if (idCategoria === 3) {
    columnClass = 'entertainment-column';
  } else if (idCategoria === 4) {
    columnClass = 'rental-column';
  } else if (idCategoria === 5) {
    columnClass = 'health-column';
  }


  useEffect(() => {
    setRubros(data.map((rubr) => ({ ...rubr, isChecked: rubr.is_selected })))
    setItemsChecked(data.map((_) => _.is_selected))
  }, [data])

  useEffect(() => {
    setTodoMarcados(itemsChecked.every((val) => val))
    const storageItemsChecked = JSON.stringify(itemsChecked)
    localStorage.setItem(`itemsChecked-${idCategoria}`, storageItemsChecked)
  }, [itemsChecked])

  return (
    <MDBCol>
      <MDBCard className="card">
        <MDBCardBody>
          <label className="titulo-container">
            <MDBCardTitle className="titulocomida">

              <input
                id="selectall"
                type="checkbox"
                className="form-check-input"
                name="allSelect"
                checked={todoMarcados}
                onChange={(_) => {
                  if (!todoMarcados) {
                    rubros.map((rubro) => (
                      handleMatrixChange(idCategoria, rubro.id, true)
                    ))
                    setTodoMarcados(true)
                    setItemsChecked([...rubros.map((_) => true)])
                  } else {
                    rubros.map((rubro) => (
                      handleMatrixChange(idCategoria, rubro.id, false)
                    ))
                    setItemsChecked([...rubros.map((_) => false)])
                  }
                }}
                align="right"
              />
              <MDBCardImage className="logoentre" alt="" src={imgSource} />
              <p>{title}</p>
            </MDBCardTitle>
          </label>

          <MDBCardText className={`check-container ${columnClass}`}>
            {rubros &&
              rubros.map((rubro, index) => {
                const handleChange = (e) => {
                  const { checked } = e.target
                  handleMatrixChange(idCategoria, rubro.id, checked)
                }

                return (
                  <span className="form-check" key={index}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name={rubro.nombre}
                      checked={itemsChecked[index]}
                      onChange={handleChange}
                      onClick={(e) => {
                        const { checked } = e.target
                        const newItemsChecked = [...itemsChecked]
                        newItemsChecked[index] = checked
                        setItemsChecked(newItemsChecked)
                      }}
                    />
                    <label className="form-check-label ms-2" style={{fontWeight: "lighter", fontSize: "15px"}}>
                      {isEnglish == 0 ? rubro.nombre : rubro.name}
                    </label>
                  </span>
                )
              })}
          </MDBCardText>
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
  )
}

Card.propTypes = {
  title: PropTypes.string.isRequired,
  imgSource: PropTypes.string,
}

export default Card
